import { Context, Data, Effect, Layer, pipe } from 'effect';
import * as Url from '../api/url';
import { GetAttachments, GetModel, } from '../requests/models/glb/requests';
import { getAttachmentsResolver, getModelResolver } from '../requests/models/glb/resolvers';
import * as Attachments from '../schemas/aspect/attachments';
export class AttachmentParseError extends Data.TaggedError('Api/Aspect/Attachments/AttachmentParseError') {
}
export const Models = Context.GenericTag('@services/Models');
export class ToastConfig extends Context.Tag('@fixtuur/backpack/ToastConfig')() {
}
export const ToastModelsService = Layer.effect(Models, Effect.gen(function* (_) {
    const toastConfig = yield* _(ToastConfig);
    const url = pipe(Url.join(toastConfig.toastUrl, '/v1'), Url.toString);
    const urlForTenant = (tenant) => pipe(Url.join(toastConfig.toastUrl, `/v1/${tenant}`), Url.toString);
    const forArticle = (tenant, productId, articleId) => Effect.gen(function* (_) {
        const request = GetModel({ tenant, productId, articleId });
        return yield* _(Effect.request(request, getModelResolver(url)));
    });
    const attachmentsForArticle = (tenant, productId, articleId) => Effect.request(GetAttachments({ tenant, productId, articleId }), getAttachmentsResolver(url)).pipe(Effect.flatMap(x => Attachments.parse(x).pipe(Effect.mapError(e => new AttachmentParseError({
        articleId,
        tenant,
        productId,
        originalError: e,
        rawAttachments: x,
    })))));
    return { url, urlForTenant, forArticle, attachmentsForArticle };
}));
